import React from 'react';
import {observer, inject} from 'mobx-react';
import {injectIntl} from 'react-intl';
import FeedbackChain from './models/FeedbackChain';
import {SplitButton, MenuItem} from 'react-bootstrap';


@injectIntl @inject('authorizationsStore', 'rootStore')  @observer
export default class CategoryToolbar extends React.Component{


    render(){
        const {feedbackChain, intl} = this.props;
        const categories = Object.values(FeedbackChain.categories);
        if( !this.props.rootStore.currentUserBelongsToStartup() ){
            const index = categories.indexOf(FeedbackChain.categories.INTERNAL);
            if (index !== -1) {
                categories.splice(index, 1);
            }
        }
        return (
            <div className={'toolbar feedback-chain-category'}>
                <div className={'title'}><i className="fa fa-life-bouy" />&nbsp;
                    {intl.formatMessage({id:"category_title"})}
                </div>
                <div className={'content'}>
                    <SplitButton
                        bsStyle={'default'}
                        title={intl.formatMessage({id: feedbackChain.category})}
                        key={feedbackChain.category}
                        id={`split-button-basic-${feedbackChain.category}`}
                        disabled={!this.props.authorizationsStore.canEditFeedback(feedbackChain)}
                    >
                        {categories.map( (s, idx) =>
                            <MenuItem key={idx} className={s} eventKey={s} onSelect={(k) => feedbackChain.setCategory(k)}>
                                {intl.formatMessage({id: s})}
                            </MenuItem>
                        )}
                    </SplitButton>
                </div>
            </div>
        );
    }
}